<template>
  <el-dialog top="29vh" width="560px" :visible.sync="passordShow"  :before-close="handClose" :loading="loading">
    <div class="login_wrap">
      <div class="login">
        <div class="tab">
          <div>忘记密码</div>
        </div>
        <el-form ref="formData" :model="formData" :rules="rules">
          <div v-if="!nextTab">
            <el-form-item prop="phone">
              <div class="label">
                <img src="@/assets/icon/phone.png" />
                <el-input placeholder="输入手机号" v-model="formData.phone"></el-input>
              </div>
            </el-form-item>
            <el-form-item prop="captcha">
              <div class="label">
                <img src="@/assets/icon/code.png" />
                <el-input class="code" placeholder="输入验证码" v-model="formData.captcha"></el-input>
                <div class="code-text" @click="!isGet && getCountdown()">{{countdown}}</div>
              </div>
            </el-form-item>
          </div>
          <div v-else>
            <el-form-item prop="password">
              <div class="label">
                <img src="@/assets/icon/password.png" />
                <el-input type="password" show-password placeholder="输入新密码" v-model="formData.password"></el-input>
              </div>
            </el-form-item>
            <el-form-item prop="passwords">
              <div class="label">
                <img src="@/assets/icon/password.png" />
                <el-input type="password" show-password placeholder="确认密码" v-model="formData.passwords"></el-input>
              </div>
            </el-form-item>
          </div>
          <el-form-item class="region">
            <el-button @click="sumbit()">{{nextTab ? '重置密码' : '下一步'}}</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import publicFun from "@/utils/publicFunction.js";
export default {
  props:{
    passordShow:{
      type: Boolean,
      default: false
    }
  },
  data() {
    let validPass1 = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("请输入手机号"));
      }
      if (!publicFun.isPhone(value)) {
        return callback(new Error("请输入正确的手机号"));
      }
      callback();
    };
    return {
      isGet: false,
      tab: 1,
      countdown: "获取验证码",
      formData: {
        phone: "",
        password: "",
        passwords: "",
        captcha: ""
      },
      loading: false,
      nextTab: false,
      rules: {
        phone: [{ validator: validPass1, trigger: "blur" }],
        captcha: [{ required: true, message: "请输入验证码", trigger: "blur" }],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
        passwords: [{ required: true, message: "请输入密码", trigger: "blur" }],
      },
      timer: null
    };
  },
  methods: {
    handClose() {
      this.$emit('closeForget' , false)
      clearInterval(this.timer);
      this.timer = null
      this.countdown = "获取验证码"
      this.nextTab = false
      this.isGet = false
    },
    // 倒计时
    getCountdown() {
      if (!publicFun.isPhone(this.formData.phone)) {
        return this.$message.error("请输入正确的手机号");
      }
      if (this.countdown != "获取验证码") return;
      this.loading = true
      this.isGet = true
      let countdown = 60;
      this.$api.sign.forgetMessage({ mobile: this.formData.phone }).then(res => {
        if(res.code == 1000){
          this.$message.success('验证码已发送')
          this.timer = window.setInterval(() => {
            if (countdown == 0) {
              this.countdown = "获取验证码";
              clearInterval(this.timer);
              this.isGet = false
            } else {
              this.countdown = `${countdown}秒`;
              countdown--;
            }
          }, 1000);
        }
      }).catch((error) => {
        this.isGet = false
      }).finally(() => {
        this.loading = false
      });
    },
    sumbit() {
      this.$refs.formData.validate(valid => {
        if (valid) {
          if (!this.nextTab) {
            //下一步
            this.$api.sign.validForgetPassword({ mobile: this.formData.phone,code: this.formData.captcha}) .then(res => {
              if (res.code == 1000) {
                this.nextTab = true
              }
            });
          } else {
            //重置密码
            if(this.formData.passwords !== this.formData.password) return this.$message.error("两次密码输入不相同!");
            let reg = /(?!^[0-9]+$)(?!^[A-z]+$)(?!^[^A-z0-9]+$)^.{8,20}$/
            if (!reg.test(this.formData.passwords)) {
              return this.$message.error('请设置8-20位密码，组合字母和数字')
            }
            this.$api.sign.forgetPassword({ mobile: this.formData.phone,newPassword: this.formData.passwords}).then(res => {
              if (res.code == 1000) {
                this.$message.success("密码重置成功,请重新登录");
                setTimeout(() => {
                  this.handClose();
                },2000)
              }
            });
          }
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.el-dialog__wrapper {
  /deep/ .el-dialog {
    &__header {
      display: block !important;
    }
    &__body {
      height: auto;
      padding: 0;
      background: #fff !important;
    }
  }
  .login_wrap{
      margin: 0;
      background: #fff;
      .login {
        width:286px;
        margin: auto;
        padding: 50px  31px;
        background: #fff;
        border-radius: 3px;
        .tab {
          line-height: 26px;
          margin-bottom: 30px;
          display: flex;
          justify-content: space-around;
          align-items: center;
          div {
            font-size:31px;
            color: #2E2E2E;
            margin-bottom: 20px;
          }
        }
        .el-form {
          .el-form-item {
              margin-bottom: 40px;
          }
          .label {
            display: flex;
            align-items: center;
            justify-content: space-between;
            position: relative;
            img {
              width: 12px;
              height: 12px;
              position: absolute;
              left: 12px;
              z-index: 2;
            }
            /deep/ .el-input {
              .el-input__inner {
                height: 46px;
                padding-left: 36px;
              }
            }
            .code {
              width: 167px;
            }
            .code-img {
              position: static;
              width: 93px;
              height: 46px;
              margin-left: 3px;
            }
            .code-text {
              position: static;
              width: 92px;
              height: 44px;
              line-height: 44px;
              margin-left: 7px;
              text-align: center;
              background: #FFF7F5;
              border: 1px solid #ef5147;
              border-radius: 2px;
              font-size: 14px;
              color: #ef5147;
              cursor: pointer;
            }
          }
          .el-button {
            width: 100%;
            font-family: PingFangSC-Regular;
            font-size: 16px;
            color: #ffffff;
            background-image: linear-gradient(-135deg, #22c686 0%, #148257 100%);
            border-radius: 2px;
          }
          .region {
            margin-top: 44px;
          }
        }
        .password {
          display: flex;
          justify-content: space-between;
          align-items: center;
          color: #aeaeb8;
        }
      }
  }
}
</style>
